import { parse } from 'query-string';
import { FIRST_PAGE } from 'Src/consts/table';
import {
  getFilters2,
  getServerFieldSectionWhere,
  getServerQueryFilter2,
  isFilterExist2,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import {
  clubProgrammeNormalizeProgrammeWhere,
  mapClubProgrammeWhereUiToServer,
  mapClubProgrammeSortUiToServer
} from 'Src/helpers/clubProgramme/clubProgramme';
import { CLUB_PROGRAMMES_GRID_COLUMNS } from '../config/clubProgrammeGridColumns';

export const normalizeClubProgrammesSortDirection = (v: any): TABLE_SORT_DIRECTION => {
  const s = String(v || '').toUpperCase();
  return s === 'ASC' || s === 'DESC' ? (s as TABLE_SORT_DIRECTION) : '';
};

type Params = {
  searchString: string;
};

export const buildClubProgrammesQueryState = ({ searchString }: Params) => {
  const search = parse(searchString || '');
  const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

  const filters = getFilters2(CLUB_PROGRAMMES_GRID_COLUMNS, search);

  const whereRaw = getServerFieldSectionWhere(filters);
  const whereMapped = mapClubProgrammeWhereUiToServer(whereRaw);
  const normalizedWhere = clubProgrammeNormalizeProgrammeWhere(whereMapped);

  let sortDirection: TABLE_SORT_DIRECTION = '';
  let sortColumnsName = '';

  if (typeof search.order === 'string') {
    const [col, dir] = String(search.order || '').split(':');
    sortColumnsName = String(col || '');
    sortDirection = normalizeClubProgrammesSortDirection(dir);
  }

  const sortFieldServer = sortColumnsName ? mapClubProgrammeSortUiToServer(sortColumnsName) : '';
  const order = sortFieldServer && sortDirection ? `${sortFieldServer} ${sortDirection}` : undefined;

  const serverQueryFilter = getServerQueryFilter2(page, normalizedWhere, order);

  const isShowFilter = false;
  const isDataFiltered = isFilterExist2(filters);

  return {
    page,
    filters,
    normalizedWhere,
    sortDirection,
    sortColumnsName,
    serverQueryFilter,
    isShowFilter,
    isDataFiltered
  };
};
